var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/autosuggest-textarea.tsx";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Portal } from '@reach/portal';
import classNames from 'clsx';
import React from 'react';
import ImmutablePureComponent from 'react-immutable-pure-component';
import Textarea from 'react-textarea-autosize';
import AutosuggestAccount from '../features/compose/components/autosuggest-account';
import { isRtl } from '../rtl';
import AutosuggestEmoji from './autosuggest-emoji';

const textAtCursorMatchesToken = (str, caretPosition) => {
  let word;
  const left = str.slice(0, caretPosition).search(/\S+$/);
  const right = str.slice(caretPosition).search(/\s/);

  if (right < 0) {
    word = str.slice(left);
  } else {
    word = str.slice(left, right + caretPosition);
  }

  if (!word || word.trim().length < 3 || !['@', ':', '#'].includes(word[0])) {
    return [null, null];
  }

  word = word.trim().toLowerCase();

  if (word.length > 0) {
    return [left + 1, word];
  } else {
    return [null, null];
  }
};

class AutosuggestTextarea extends ImmutablePureComponent {
  constructor() {
    super(...arguments);

    _defineProperty(this, "textarea", null);

    _defineProperty(this, "state", {
      suggestionsHidden: true,
      focused: false,
      selectedSuggestion: 0,
      lastToken: null,
      tokenStart: 0
    });

    _defineProperty(this, "onChange", e => {
      const [tokenStart, token] = textAtCursorMatchesToken(e.target.value, e.target.selectionStart);

      if (token !== null && this.state.lastToken !== token) {
        this.setState({
          lastToken: token,
          selectedSuggestion: 0,
          tokenStart
        });
        this.props.onSuggestionsFetchRequested(token);
      } else if (token === null) {
        this.setState({
          lastToken: null
        });
        this.props.onSuggestionsClearRequested();
      }

      this.props.onChange(e);
    });

    _defineProperty(this, "onKeyDown", e => {
      const {
        suggestions,
        disabled
      } = this.props;
      const {
        selectedSuggestion,
        suggestionsHidden
      } = this.state;

      if (disabled) {
        e.preventDefault();
        return;
      }

      if (e.which === 229 || e.isComposing) {
        // Ignore key events during text composition
        // e.key may be a name of the physical key even in this case (e.x. Safari / Chrome on Mac)
        return;
      }

      switch (e.key) {
        case 'Escape':
          if (suggestions.size === 0 || suggestionsHidden) {
            var _document$querySelect, _document$querySelect2;

            (_document$querySelect = document.querySelector('.ui')) === null || _document$querySelect === void 0 ? void 0 : (_document$querySelect2 = _document$querySelect.parentElement) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.focus();
          } else {
            e.preventDefault();
            this.setState({
              suggestionsHidden: true
            });
          }

          break;

        case 'ArrowDown':
          if (suggestions.size > 0 && !suggestionsHidden) {
            e.preventDefault();
            this.setState({
              selectedSuggestion: Math.min(selectedSuggestion + 1, suggestions.size - 1)
            });
          }

          break;

        case 'ArrowUp':
          if (suggestions.size > 0 && !suggestionsHidden) {
            e.preventDefault();
            this.setState({
              selectedSuggestion: Math.max(selectedSuggestion - 1, 0)
            });
          }

          break;

        case 'Enter':
        case 'Tab':
          // Select suggestion
          if (this.state.lastToken !== null && suggestions.size > 0 && !suggestionsHidden) {
            e.preventDefault();
            e.stopPropagation();
            this.props.onSuggestionSelected(this.state.tokenStart, this.state.lastToken, suggestions.get(selectedSuggestion));
          }

          break;
      }

      if (e.defaultPrevented || !this.props.onKeyDown) {
        return;
      }

      this.props.onKeyDown(e);
    });

    _defineProperty(this, "onBlur", () => {
      this.setState({
        suggestionsHidden: true,
        focused: false
      });

      if (this.props.onBlur) {
        this.props.onBlur();
      }
    });

    _defineProperty(this, "onFocus", () => {
      this.setState({
        focused: true
      });

      if (this.props.onFocus) {
        this.props.onFocus();
      }
    });

    _defineProperty(this, "onSuggestionClick", e => {
      var _this$textarea;

      const suggestion = this.props.suggestions.get(e.currentTarget.getAttribute('data-index'));
      e.preventDefault();
      this.props.onSuggestionSelected(this.state.tokenStart, this.state.lastToken, suggestion);
      (_this$textarea = this.textarea) === null || _this$textarea === void 0 ? void 0 : _this$textarea.focus();
    });

    _defineProperty(this, "setTextarea", c => {
      this.textarea = c;
    });

    _defineProperty(this, "onPaste", e => {
      if (e.clipboardData && e.clipboardData.files.length === 1) {
        this.props.onPaste(e.clipboardData.files);
        e.preventDefault();
      }
    });

    _defineProperty(this, "renderSuggestion", (suggestion, i) => {
      const {
        selectedSuggestion
      } = this.state;
      let inner, key;

      if (typeof suggestion === 'object') {
        inner = /*#__PURE__*/React.createElement(AutosuggestEmoji, {
          emoji: suggestion,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 205,
            columnNumber: 15
          }
        });
        key = suggestion.id;
      } else if (suggestion[0] === '#') {
        inner = suggestion;
        key = suggestion;
      } else {
        inner = /*#__PURE__*/React.createElement(AutosuggestAccount, {
          id: suggestion,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 211,
            columnNumber: 15
          }
        });
        key = suggestion;
      }

      return /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: 0,
        key: key,
        "data-index": i,
        className: classNames({
          'px-4 py-2.5 text-sm text-gray-700 dark:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800 focus:bg-gray-100 dark:focus:bg-primary-800 group': true,
          'bg-gray-100 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-800': i === selectedSuggestion
        }),
        onMouseDown: this.onSuggestionClick,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 216,
          columnNumber: 7
        }
      }, inner);
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Skip updating when only the lastToken changes so the
    // cursor doesn't jump around due to re-rendering unnecessarily
    const lastTokenUpdated = this.state.lastToken !== nextState.lastToken;
    const valueUpdated = this.props.value !== nextProps.value;

    if (lastTokenUpdated && !valueUpdated) {
      return false;
    } else {
      return super.shouldComponentUpdate(nextProps, nextState, undefined);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      suggestions
    } = this.props;

    if (suggestions !== prevProps.suggestions && suggestions.size > 0 && prevState.suggestionsHidden && prevState.focused) {
      this.setState({
        suggestionsHidden: false
      });
    }
  }

  setPortalPosition() {
    if (!this.textarea) {
      return {};
    }

    const {
      top,
      height,
      left,
      width
    } = this.textarea.getBoundingClientRect();
    return {
      top: top + height,
      left,
      width
    };
  }

  render() {
    const {
      value,
      suggestions,
      disabled,
      placeholder,
      onKeyUp,
      autoFocus,
      children,
      condensed,
      id
    } = this.props;
    const {
      suggestionsHidden
    } = this.state;
    const style = {
      direction: 'ltr',
      minRows: 10
    };

    if (isRtl(value)) {
      style.direction = 'rtl';
    }

    return [/*#__PURE__*/React.createElement("div", {
      key: "textarea",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 256,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "relative",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 257,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("label", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 258,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'none'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 259,
        columnNumber: 13
      }
    }, placeholder), /*#__PURE__*/React.createElement(Textarea, {
      ref: this.setTextarea,
      className: classNames('transition-[min-height] motion-reduce:transition-none dark:bg-transparent px-0 border-0 text-gray-800 dark:text-white placeholder:text-gray-600 dark:placeholder:text-gray-600 resize-none w-full focus:shadow-none focus:border-0 focus:ring-0', {
        'min-h-[40px]': condensed,
        'min-h-[100px]': !condensed
      }),
      id: id,
      disabled: disabled,
      placeholder: placeholder,
      autoFocus: autoFocus,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onKeyUp: onKeyUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onPaste: this.onPaste,
      style: style,
      "aria-autocomplete": "list",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 261,
        columnNumber: 13
      }
    }))), children), /*#__PURE__*/React.createElement(Portal, {
      key: "portal",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 287,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: this.setPortalPosition(),
      className: classNames({
        'fixed z-1000 shadow bg-white dark:bg-gray-900 rounded-lg py-1 space-y-0 dark:ring-2 dark:ring-primary-700 focus:outline-none': true,
        hidden: suggestionsHidden || suggestions.isEmpty(),
        block: !suggestionsHidden && !suggestions.isEmpty()
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 288,
        columnNumber: 9
      }
    }, suggestions.map(this.renderSuggestion)))];
  }

}

_defineProperty(AutosuggestTextarea, "defaultProps", {
  autoFocus: true
});

export default AutosuggestTextarea;